/**
 * 是否使用周边游城市推荐列表
 * 当 sceneType === 'TRAVEL_AROUND_SALE' 时，使用后端推荐的周边游城市列表，返回 true
 * 否则使用外部传入的城市列表（cityIdList / cityNameList），返回 false
 */
export function useRecommendCityList(sceneType) {
    return sceneType === 'TRAVEL_AROUND_SALE';
}
